import script from "./InvoiceSection6.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceSection6.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceSection6.vue?vue&type=style&index=0&id=3ec688a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ec688a3"]])

export default __exports__